// extracted by mini-css-extract-plugin
module.exports = {"clientCreationTitle":"modal-client-creation_clientCreationTitle__2ZSrs","modalContainer":"modal-client-creation_modalContainer__3n5sn"};